import client from './main-client';

export const getGuestDealApi = (params) => client().get('/guest-deal', { params });
